




































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class User extends Vue {
    private loading = false;
    private unitTree: any[] = [];
    private defaultProps = {
        children: 'children',
        label: 'name'
    }
    private curUnitId = 0;

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};

    private moveVisible = false;
    private moveUnitId = 0;
    private token = {
        "Authorization": "Bearer " + this.$store.state.token
    };
    private hasChildren = true;
    private search = "";

    created() {
        this.reloadTree();
    }

    // 加载机构树
    reloadTree() {
        this.$apis.getMyUnitTree()
            .then((res: any) => {
                this.unitTree = res.data;

                this.pageIndex = 1;
                this.curUnitId = this.unitTree[0].id;
                this.reload();
            });
    }

    reload() {
        this.$apis.getUsersByUnit(this.curUnitId, this.hasChildren, this.search, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;

            });
    }

    // 选中机构-加载下级机构列表
    onChildUnit(data: any) {
        this.curUnitId = data.id;
        this.pageIndex = 1;
        this.reload();
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {

            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delUsers({ data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 重置密码
    onPassword(id: number) {
        this.$confirm('此操作将重置用户密码为Xfzd@119, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {

            this.$apis.putUserPassword(id)
                .then((res: any) => {

                    this.$message({
                        type: 'success',
                        message: '重置成功!'
                    });
                });
        });
    }

    // 人员调度
    onMove() {
        this.moveUnitId = this.curUnitId;
        this.moveVisible = true;
    }

    // 选中机构-加载下级机构列表
    onMoveChildUnit(data: any) {
        this.moveUnitId = data.id;
    }

    onTransfer() {
        this.moveVisible = false;
        this.$confirm('此操作将用户调度到新单位下, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {

            var ids = this.multipleSelection.map(item => item.id);
            this.$apis.putUserTransfer(this.moveUnitId, { ids: ids })
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 新增
    onAdd() {
        this.editForm = {
            userName: "",
            phone: "",
            unitId: this.curUnitId,
            role: "用户",
            duty: "",
            nickName: "",
            sequence: 1000
        }
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        this.editForm = {
            id: row.id,
            userName: row.userName,
            phone: row.phone,
            unitId: this.curUnitId,
            role: row.role,
            duty: row.duty,
            nickName: row.nickName,
            sequence: row.sequence
        }
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;

        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postUser(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                });
        } else {
            // 编辑
            this.$apis.putUser(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }

    }

    onSucess(res: any) {
        if (res.code == 100) {
            this.$message({
                type: 'warning',
                message: '提交成功，但存在以下错误：' + res.msg
            });
        } else {
            this.$message({
                type: 'success',
                message: '提交成功'
            });
        }
        this.reload(); // 刷新列表
        (this.$refs.upload as any).clearFiles();
    }

    onError(err: any) {
        this.$message({
            type: 'error',
            message: err
        });
    }
}
